var map = {
	"./ava1.png": 374,
	"./ava10.png": 7787,
	"./ava11.png": 1453,
	"./ava2.png": 6237,
	"./ava3.png": 5302,
	"./ava4.png": 4540,
	"./ava5.png": 2535,
	"./ava6.png": 3727,
	"./ava7.png": 3113,
	"./ava8.png": 8031,
	"./ava9.png": 5929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3759;